import type { FC } from 'react';
import type { LineProps } from './index';

export const DottedLine: FC<LineProps> = ({ color, width, height }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 88 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            {Array.from({ length: 20 }).map((_, index) => (
                <circle key={index} cx={index * 8 + height! / 2} cy={height! / 2} r={height! / 2} fill={color} />
            ))}
        </svg>
    );
};
